// shop/fader.js — мягкая смена фотографий экземпляров
// =============================================================================
// Карточка на витрине и главный снимок на странице товара показывают не одну
// картинку, а все экземпляры по очереди: медленное перекрестное затухание,
// без сдвигов и рывков.
//
// Разметка (её готовит шаблон, скрипт только переключает класс):
//   <div class="…-fade" data-fade>
//     <img class="is-active"> <img> <img>
//   </div>
//
// Само затухание — на CSS (opacity + transition), поэтому анимация идёт
// в компоновщике и не грузит основной поток.
//
// Что учтено:
//   • prefers-reduced-motion — смены нет вообще, остаётся первый кадр;
//   • за экраном таймер не тикает (IntersectionObserver);
//   • у каждого блока свой сдвиг фазы, иначе вся сетка мигает одновременно.

const INTERVAL = 4200;
const STAGGER = 900;

const groups = [];
let timer = null;

function advance(group) {
  const images = group.images;
  if (images.length < 2) return;

  images[group.index].classList.remove('is-active');
  group.index = (group.index + 1) % images.length;
  const next = images[group.index];

  // Соседние кадры ленивые: подгружаем заранее, иначе первый показ мигнёт.
  if (next.dataset.src && !next.src) next.src = next.dataset.src;
  next.classList.add('is-active');

  const after = images[(group.index + 1) % images.length];
  if (after.dataset.src && !after.src) after.src = after.dataset.src;
}

function tick() {
  const now = Date.now();
  groups.forEach(group => {
    if (!group.visible) return;
    if (now - group.last < INTERVAL + group.offset) return;
    group.last = now;
    advance(group);
  });
}

export function init() {
  const nodes = Array.from(document.querySelectorAll('[data-fade]'));
  if (!nodes.length) return;

  // Уважаем системную настройку: анимации отключены — показываем один кадр.
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  if (reduced.matches) return;

  nodes.forEach((node, i) => {
    const images = Array.from(node.querySelectorAll('img'));
    if (images.length < 2) return;
    groups.push({
      node,
      images,
      index: 0,
      visible: false,
      last: Date.now(),
      offset: (i % 4) * STAGGER,
    });
  });

  if (!groups.length) return;

  if ('IntersectionObserver' in window) {
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        const group = groups.find(g => g.node === entry.target);
        if (group) group.visible = entry.isIntersecting;
      });
    }, { rootMargin: '100px' });
    groups.forEach(g => observer.observe(g.node));
  } else {
    groups.forEach(g => { g.visible = true; });
  }

  // Один таймер на все блоки — дешевле, чем интервал на каждую карточку.
  timer = setInterval(tick, 600);

  // Во вкладке в фоне анимировать нечего.
  document.addEventListener('visibilitychange', () => {
    if (document.hidden) {
      clearInterval(timer);
      timer = null;
    } else if (!timer) {
      groups.forEach(g => { g.last = Date.now(); });
      timer = setInterval(tick, 600);
    }
  });
}

// Ручной выбор кадра (точки под галереей товара).
export function show(node, index) {
  const group = groups.find(g => g.node === node);
  if (!group) return;
  group.images[group.index].classList.remove('is-active');
  group.index = index % group.images.length;
  const img = group.images[group.index];
  if (img.dataset.src && !img.src) img.src = img.dataset.src;
  img.classList.add('is-active');
  group.last = Date.now();
}
